import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "class-view" }
const _hoisted_2 = { class: "class-view-header d-flex justify-space-between" }
const _hoisted_3 = { class: "operate-area d-flex justify-space-between mr-4" }
const _hoisted_4 = { class: "d-flex" }

import {useApi} from "@/api/handler";
import {classes} from "@/api";
import {ApiMap} from "@/api/type";
import {onMounted, ref} from "vue";
import NewClass from "@/components/class/NewClass.vue";
import ClassCards from "@/components/class/ClassCards.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClassView',
  setup(__props) {

const tab = ref<string>('one')
const overlay = ref<boolean>(false)
const classList = ref<ApiMap['/class/list']['resp'] | null>(null)
const keyWord = ref<string>('')

function handleClose() {
  overlay.value = false
  useClassList()
}

onMounted(() => {
  useClassList()
})

const useClassList = () => {
  useApi({
    api: classes.ClassList(1, 10, keyWord.value),
    onSuccess: resp => {
      classList.value = resp.data as ApiMap['/class/list']['resp']
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_tabs, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
        class: "ml-10",
        height: "60px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, {
            value: "one",
            class: "tabs-title"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("我的班级")
            ])),
            _: 1,
            __: [5]
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_v_divider),
    _createVNode(_component_v_tabs_window, {
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tab).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tabs_window_item, {
          value: "one",
          class: "pa-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_text_field, {
                  modelValue: keyWord.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((keyWord).value = $event)),
                  class: "ml-6",
                  variant: "outlined",
                  density: "compact",
                  rounded: "",
                  width: "300px",
                  "append-inner-icon": "mdi-magnify",
                  placeholder: "搜索班级",
                  "hide-details": "",
                  clearable: "",
                  "single-line": "",
                  "onClick:appendInner": useClassList,
                  "onClick:clear": useClassList
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "outlined",
                rounded: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (overlay.value = true))
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("添加班级")
                ])),
                _: 1,
                __: [6]
              })
            ]),
            (classList.value)
              ? (_openBlock(), _createBlock(ClassCards, {
                  key: 0,
                  data: classList.value.list
                }, null, 8, ["data"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_overlay, {
      modelValue: overlay.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((overlay).value = $event)),
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        _createVNode(NewClass, { onClose: handleClose })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})